import {
    type ApproveCommercialOpportunityRequestResponseType,
    type ApproveCommercialOpportunityRequestRequestType
} from "./type";
import {
    request
} from "../request";

const approveCommercialOpportunityRequest = async (
    params: ApproveCommercialOpportunityRequestRequestType
): Promise<ApproveCommercialOpportunityRequestResponseType> => {
    return await request<ApproveCommercialOpportunityRequestResponseType>(
        "/request/approveCommercialOpportunityRequest",
        {
            body: JSON.stringify(params),
            method: "POST"
        }
    );
};
export default approveCommercialOpportunityRequest;
